import {Divider, Menu, Zoom} from '@mui/material';
import Paper from '@mui/material/Paper';
import React, {useRef, useState} from 'react';
import Edit from '@mui/icons-material/Edit';
import {observer} from 'mobx-react';
import ControlButton from "../../Common/ControlButton";
import Box from "../../Common/Box";
import DeleteForever from "@mui/icons-material/DeleteForever";
import AddReaction from "@mui/icons-material/AddReaction";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import {Message} from "../../lib/stores/MessageStore";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import MenuItem from "@mui/material/MenuItem";
import MessageReactions from "./MessageReactions";
import {useTheme} from "@mui/material/styles";
import {notifier} from "../../lib/Notifier";
import uiStore from "../../lib/stores/uiStore";
import {DesktopReactionPanel} from "../ReactionPanel/DesktopReactionPanel";

interface ControlsProps {
    message: Message,
    visible: boolean,
    onEditPressed: () => any,
}

export default observer(function Controls({message, visible, onEditPressed}: ControlsProps) {

    const controlSize = 24;
    const theme = useTheme();
    const [reactionPanelOpen, setReactionPanelOpen] = useState(false);
    const [messageMenuOpen, setMessageMenuOpen] = useState(false);
    const [messageReactionsOpen, setMessageReactionsOpen] = useState(false);

    const controlsRef = useRef();
    const isAuthor = message.author.id === shadowClient.userId;
    const backgroundColor = theme.palette.mode === "dark" ? "#393939" : "#efefef";

    return <Box
            zIndex={1}
            row
            padding={"0px"}
            position={"absolute"}
            right={0}
            top={"-13px"}
            style={{
                pointerEvents: "none"
            }}
    >
        <Box
                style={{
                    position: "relative",
                }}
        >
            <Box
                    style={{
                        pointerEvents: "all",
                        width: "50%",
                        position: "absolute",
                        height: "100%",
                    }}

            />
            <Zoom in={visible}>
                <Paper
                        ref={controlsRef}
                        elevation={4} style={{
                    display: "flex",
                    padding: "4px",
                    position: "relative",
                    pointerEvents: visible ? "all" : "none"
                }}>
                    <ControlButton
                            // ref={reactionButtonRef}
                            width={controlSize}
                            icon={AddReaction}
                            onClick={async () => {
                                if (uiStore.isMobile) {
                                    uiStore.reactionPanelMessage = message;
                                } else {
                                    setReactionPanelOpen(true);
                                }

                            }}
                    />
                    <DesktopReactionPanel
                            message={message}
                            open={reactionPanelOpen}
                            anchorEl={controlsRef}
                            onClose={() => setReactionPanelOpen(false)}
                    />
                    {isAuthor && <> <ControlButton
                            width={controlSize}
                            icon={Edit}
                            onClick={() => {
                                if (uiStore.isMobile) {
                                    uiStore.editedMessage = message;
                                } else {
                                    onEditPressed();
                                }

                            }}
                    />
                        <ControlButton
                                width={controlSize}
                                icon={DeleteForever}
                                onClick={async () => {
                                    try {
                                        await shadowClient.deleteMessage(message.room_id, message.id);
                                    } catch (e) {
                                        notifier.error("Failed to delete message. Error: " + e.message);
                                    }

                                }}
                        /></>}
                    <ControlButton
                            // ref={reactionButtonRef}
                            width={controlSize}
                            icon={MoreHoriz}
                            onClick={async () => {
                                setMessageMenuOpen(true);
                            }}
                            // onClick={async () => {
                            //     setMessageReactionsOpen(true);
                            // }}
                    />
                    <Menu
                            anchorEl={controlsRef.current}
                            open={messageMenuOpen}
                            onClose={() => setMessageMenuOpen(false)}
                            MenuListProps={{
                                dense: true,
                                sx: {
                                    background: backgroundColor,
                                    fontSize: "14px",
                                }
                            }}
                            onClick={() => setMessageMenuOpen(false)}
                    >
                        <MenuItem
                                sx={{
                                    minHeight: "initial",
                                    padding: "2px 12px",
                                    fontStyle: "italic",
                                    fontSize: "12px"
                                }}
                                disabled={true}
                        >
                            {message.timestamp}
                        </MenuItem>
                        <Divider/>
                        <MenuItem
                                disabled={!message.reactions?.length}
                                onClick={() => {
                                    // setMessageMenuOpen(false);
                                    setMessageReactionsOpen(true)
                                }}>
                            Show reactions
                        </MenuItem>
                    </Menu>

                    {message.reactions?.length > 0 &&
                            <MessageReactions
                                    message={message}
                                    open={messageReactionsOpen}
                                    onClose={() => setMessageReactionsOpen(false)}
                            />
                    }
                </Paper>
            </Zoom>
        </Box>
    </Box>
});
